import React from 'react';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './Rider.css';
import getAllHomePageSettings from './getAllHomePageSettings.graphql'
import Page from '../../../components/Page/Page';
import SafetyGrid from '../../../components/Home/SafetyGrid/SafetyGrid';
import { HomeProvider } from '../../context/homeContext'
import FooterImageSection from '../../../components/Home/FooterImageSection/FooterImageSection';

class Rider extends React.Component {

  render() {
    const { getAllHomePageSettings: { loading, getAllHomePageSettings }, data } = this.props
    let homeSettings = {}
    if (!loading) {
      getAllHomePageSettings && getAllHomePageSettings.homePageData.map((item) => {
        homeSettings[item.name] = item.value
      })
    }
    return (
      <div>
        {!loading &&
          <div>
            <HomeProvider value={homeSettings}>
              <div className={s.homeBanner} />
              <Page
                html={data && data.content}
                title={data && data.metaTitle}
                pageBanner={data && data.pageBanner}
              />
              <div className={s.riderBlog}>
                <SafetyGrid />
              </div>
              <FooterImageSection />
            </HomeProvider>
          </div>}
      </div>
    );
  }
}

export default compose(
  withStyles(s),
  graphql(getAllHomePageSettings, {
    name: 'getAllHomePageSettings',
    options: {
      ssr: true
    }
  })
)(Rider);
